import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal, { modalStyles as m } from "./Modal";
import { applyCoupon, setOutdoor, clearOrderDiscount } from "../../../Redux/features/WebRegister/cartSlice";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { roundHalfUp } from "../engine";
import { fmt } from "../uiUtils";
import NumericInput from "../NumericInput";

// Out-The-Door price — EXACT port of OrderCreateViewModel.getDiscountForOutdoorPrice:
//   tempSubTotal = subtotal − lotteryBuyAmount
//   totalTaxPct  = Σ over current tax buckets (bucket$ / tempSubTotal × 100)   // blended effective rate
//   newAmount    = roundHalfUp( t² / (t + t·totalTaxPct/100) )                 // pre-tax base for target t
//   discount     = tempSubTotal − newAmount
// Applied as a $-coupon named "OTD" (flag "1") with isOutdoor — the same coupon path Android uses —
// so the final total (base + recomputed tax) lands ON the target, not under it.
export default function OtdModal({ initialAmount, onApplied, onClose }) {
  const dispatch = useDispatch();
  const totals = useSelector((st) => st.webRegisterCart.totals);
  const grand = totals.grandTotal;
  // Prefill from the keypad amount (POS getInputAmount) when one was keyed, else the current total.
  const [target, setTarget] = useState(Number(initialAmount) > 0 ? Number(initialAmount) : grand);

  const apply = () => {
    const t = Number(target) || 0;
    if (t <= 0 || t >= grand) return ToastifyAlert("Entered amount must be less than the total", "error"); // Android: inputAmount >= mGrandTotal
    const tempSub = roundHalfUp((totals.subtotal || 0) - (totals.lotteryBuyAmount || 0));
    if (tempSub <= 0) return ToastifyAlert("Cart is empty", "error");
    const totalTaxPct = (totals.taxLines || []).reduce(
      (s, tx) => s + ((Number(tx.amount) || 0) / tempSub) * 100,
      0
    );
    const outdoorTax = (t * totalTaxPct) / 100;
    const newAmount = roundHalfUp((t * t) / (t + outdoorTax)); // = t / (1 + pct/100), Android form kept
    const discount = roundHalfUp(tempSub - newAmount);
    if (discount <= 0) return ToastifyAlert("Target must be below the current total", "error");
    dispatch(
      applyCoupon({ name: "OTD", id: "", discount: String(discount), flag: "1", minAmount: "0", maximumDiscount: "0", isOutdoor: true })
    );
    dispatch(setOutdoor({ price: t }));
    if (onApplied) onApplied(); // clear the keypad amount (POS clearItemAmount)
    onClose();
  };

  return (
    <Modal title="Out-the-door price" onClose={onClose}>
      <div style={m.label}>Current total: {fmt(grand)}</div>
      <div style={{ ...m.label, marginTop: 12 }}>Target out-the-door total</div>
      <NumericInput style={m.input} value={target} onChange={setTarget} decimals={2} max={grand} onEnter={apply} autoFocus />
      <button style={m.primary} onClick={apply}>Set OTD price</button>
      <button style={m.ghost} onClick={() => { dispatch(clearOrderDiscount()); onClose(); }}>Clear OTD</button>
    </Modal>
  );
}
